import React from 'react'
import cn from 'classnames'

import styles from './ConnectingIndicator.module.scss'
import { ReactComponent as LoadingIcon } from '../assets/loading.svg'

const ConnectingIndicator = ({ className, ...props }) => {
  const classNames = cn(styles.connectingIndicator, className)

  return (
    <div {...props} className={classNames}>
      <LoadingIcon className={styles.loadingSpinner} />
    </div>
  )
}

export default ConnectingIndicator
